import React from 'react';
import '../styles/HomePage.css';

const Footer: React.FC = () => {
  return (
    <footer>
      <div className='footer-content'>
        <p>
          <a href='#' className='footer-link'>
            Naval Postgraduate School Foundation
          </a>{' '}
          is a 501(c)(3) tax-exempt, national nonprofit charitable organization.
          NPSF is a non-federal entity. It is not part of the Department of
          Defense or any of its components and has no governmental status.
        </p>
        <p>
          &copy; 2023 |{' '}
          <a href='#' className='footer-link'>
            Privacy Policy
          </a>
        </p>
        <p>Powered and secured by the Naval Postgraduate School Foundation</p>
      </div>
    </footer>
  );
};

export default Footer;
